import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgForOf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppInfos, AuthSessionDto, ROLE_WORKSPACE_USER, ROLE_WORKSPACE_USER_LABELS } from 'src/app/app.models';
import { AuthService } from 'src/app/@auth/auth.service';
import { AppService } from 'src/app/services/app.service';
import { CluLockscreenService, LOCKSCREEN_MODE } from 'src/app/utils/clu-lockscreen/clu-lockscreen.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ZBEQuickActionsBottomSheetComponent } from 'src/app/@clu-be/zcoreutils/zbe-quickactions-bottom-sheet/zbe-quickactions-bottom-sheet.component';
import { MdAboutComponent } from '../../md-about/md-about.component';
import { CluConfirmDialogService } from 'src/app/utils/clu-confirm-dialog/clu-confirm-dialog.service';
import { CluBeSnackbarService } from "src/app/@clu-be/apps/@services/clube-snackbar.service";
import { TauriService } from 'src/app/services/tauri/tauri.service';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, NgScrollbarModule, TablerIconsModule, MaterialModule, TranslateModule],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  public selectedLanguage: any = {
    language: 'Français',
    code: 'fr',
    icon: 'assets/images/flag/icon-flag-fr.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'Arabe',
      code: 'ar',
      icon: 'assets/images/flag/icon-flag-ar.png',
    },
    {
      language: 'Espagnol',
      code: 'es',
      icon: 'assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Allemand',
      code: 'de',
      icon: 'assets/images/flag/icon-flag-de.svg',
    }
  ];

  ROLE_WORKSPACE_USER_LABELS = ROLE_WORKSPACE_USER_LABELS;
  authSessionDto: AuthSessionDto;
  appVersion: AppInfos;
  isTestEnv = false;
  isPreprodEnv: boolean = ['development', 'preprod'].includes(this._appService.appVersion$.value.APP_ENVIRONMENT.toLocaleLowerCase());
  isTauri = false;

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private cluLockscreenService: CluLockscreenService,
    private _appService: AppService,
    private _bottomSheet: MatBottomSheet,
    private _confirmationService: CluConfirmDialogService,
    private _snackbarService : CluBeSnackbarService,
    private _tauriService: TauriService
  ) {
    //translate.setDefaultLang('fr');
    let _language = localStorage.getItem('CAURIS_LINKUP_LANG') || 'fr';
    translate.setDefaultLang(_language);
    this.selectedLanguage = this.languages.find(_lang => _lang.code == _language);

    this.authSessionDto = authService.authenticatedSession$.value!;
    this.appVersion = _appService.appVersion$.value;
    this.isTestEnv = _appService.isBackendTestEnv;
    this.isTauri = this._tauriService.isTauri;
  }

  async doMinimizeApp() {
    await this._tauriService.minimizeApp();
  }

  async doQuitApp() {
    const confirmation = await this._confirmationService.showConfirmDialog("Cauris Linkup", "Voulez-vous vraiment quitter l'application ?");
    if (confirmation == true) {
      await this._tauriService.quitApp();
    }
  }

  doLogout() {
    if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.USER_WORKSPACE) {
      this.authService.doSignoutFOAction();
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl('/login');
    } else if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.ADMIN_WORKSPACE || this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.SUPER_ADMIN_WORKSPACE) {
      this.authService.doSignoutAdminAction();
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl("/cluadmin/login");
    } else {
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl('/login');
    }
  }

  async doLockAccount() {
    this.authService.doLockSession();
  }

  async doSwitchToTestEnvironment() {
      const confirmation = await this._confirmationService.showConfirmDialog("Environnement de test", "Êtes-vous sûr de vouloir basculer vers l'environnement de test ? L'application va redémarrer.");
      if (confirmation == true) {
        try {
            await this._appService.doSwitchBOToTestEnvironmentAction();
            this._snackbarService.displayMessage("SUCCESS", "La bascule vers l'environnement de test a bien été effectuée. L'application va redémarrer.");
            location.href = "/cluadmin";
        } catch (error: any) {
            this._snackbarService.displayMessage("ERROR", error);
        }
      }
  }

  async doSwitchToProdEnvironment() {
      const confirmation = await this._confirmationService.showConfirmDialog("Environnement de test", "Êtes-vous sûr de vouloir basculer vers l'environnement de production ? L'application va redémarrer.");
      if (confirmation == true) {
          localStorage.removeItem('LS_BE_SESSION_TEST_ENV');
          location.href = "/cluadmin";
      }
  }

  openZBEQuickActionsBottomSheet(): void {
    this._bottomSheet.open(ZBEQuickActionsBottomSheetComponent);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openAboutDialog() {
    const dialogRef = this.dialog.open(MdAboutComponent, {
      width: '100%', maxWidth: '500px', minHeight: '750px', maxHeight: '750px', height : '100%',
      data: { }
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    localStorage.setItem('CAURIS_LINKUP_LANG', lang.code);
    this.selectedLanguage = lang;
  }

  notifications: notifications[] = [ ];

  profiledd: profiledd[] = [ ];

  apps: apps[] = [
    {
      id: 1,
      img: 'assets/images/svgs/module-caisse.png',
      title: 'Caisse',
      subtitle: 'Module caisse',
      link: '/',
    },
    {
      id: 2,
      img: 'assets/images/svgs/module-saisie.png',
      title: 'Saisie décentralisée',
      subtitle: 'Module saisie décentralisée',
      link: '/',
    },
    {
      id: 3,
      img: 'assets/images/svgs/module-inventaire.png',
      title: 'Inventaire',
      subtitle: 'Module Inventaire',
      link: '/',
    },
    {
      id: 4,
      img: 'assets/images/svgs/module-mvts-caisse.png',
      title: 'Mouvements caisse',
      subtitle: 'Module caisse',
      link: '/',
    }
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/t',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/',
    },
  ];
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    NgForOf,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
